import Vue from 'vue';
import {Component} from 'vue-property-decorator';

@Component({
  template: `
<transition name="fade">
  <div class="validation-errors" v-if="error">
    <slot></slot>
  </div>
</transition>
`,
  props: {
    error: Boolean
  }
})
export class SpinnerComponent extends Vue {
  error: boolean;
}

Vue.component('validation-error', SpinnerComponent);



// WEBPACK FOOTER //
// ./src/components/validation-error/validation-error.ts